<template>
    <div>
        <ValidationObserver ref="form" v-slot="{ invalid, validate, dirty }">
            <form
                autocomplete="off"
                @submit.prevent="validate().then(updateSettings)"
            >
                <div class="row">
                    <div class="col-12"><h4>1 Day Past Due Message</h4></div>
                    <div class="col-6">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Day 1 Net 15"
                            rules="required"
                        >
                            <base-input
                                name="day1Net15"
                                label="Net 15"
                                :error="errors[0]"
                            >
                                <textarea
                                    v-model="invoiceMessages.day1.net15"
                                    style="max-height: unset"
                                    class="form-control"
                                    rows="3"
                                />
                            </base-input>
                        </ValidationProvider>
                    </div>
                    <div class="col-6">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Day 1 Net 30"
                            rules="required"
                        >
                            <base-input
                                name="day1Net30"
                                label="Net 30"
                                :error="errors[0]"
                            >
                                <textarea
                                    v-model="invoiceMessages.day1.net30"
                                    style="max-height: unset"
                                    class="form-control"
                                    rows="3"
                                />
                            </base-input>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12"><h4>15 Days Past Due Message</h4></div>
                    <div class="col-6">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Day 15 Net 15"
                            rules="required"
                        >
                            <base-input
                                name="day15Net15"
                                label="Net 15"
                                :error="errors[0]"
                            >
                                <textarea
                                    v-model="invoiceMessages.day15.net15"
                                    style="max-height: unset"
                                    class="form-control"
                                    rows="3"
                                />
                            </base-input>
                        </ValidationProvider>
                    </div>
                    <div class="col-6">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Day 15 Net 30"
                            rules="required"
                        >
                            <base-input
                                name="day15Net30"
                                label="Net 30"
                                :error="errors[0]"
                            >
                                <textarea
                                    v-model="invoiceMessages.day15.net30"
                                    style="max-height: unset"
                                    class="form-control"
                                    rows="3"
                                />
                            </base-input>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12"><h4>30 Days Past Due Message</h4></div>
                    <div class="col-6">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Day 30 Net 15"
                            rules="required"
                        >
                            <base-input
                                name="day30Net15"
                                label="Net 15"
                                :error="errors[0]"
                            >
                                <textarea
                                    v-model="invoiceMessages.day30.net15"
                                    style="max-height: unset"
                                    class="form-control"
                                    rows="3"
                                />
                            </base-input>
                        </ValidationProvider>
                    </div>
                    <div class="col-6">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Day 30 Net 30"
                            rules="required"
                        >
                            <base-input
                                name="day30Net30"
                                label="Net 30"
                                :error="errors[0]"
                            >
                                <textarea
                                    v-model="invoiceMessages.day30.net30"
                                    style="max-height: unset"
                                    class="form-control"
                                    rows="3"
                                />
                            </base-input>
                        </ValidationProvider>
                    </div>
                </div>
                <base-button
                    :disabled="invalid || !dirty"
                    native-type="submit"
                    type="primary"
                    class="btn-fill"
                >
                    Update
                </base-button>
            </form>
        </ValidationObserver>
    </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
    name: "SettingsInvoices",
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    props: {
        settings: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            invoiceMessages: { ...this.settings.pastDueInvoiceMessages },
        };
    },
    methods: {
        updateSettings() {
            this.$emit("updateSettings", {
                input: { pastDueInvoiceMessages: this.invoiceMessages },
            });
            this.$refs.form.reset();
        },
    },
};
</script>
